import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';
import { getBreadcrumbSchema, getBreadcrumbTrail } from '../utils/schema';

/**
 * Schema 6 — BreadcrumbList. Rendered from Wrapper, so every inner page gets it
 * without touching each page; the homepage and routes without a known label
 * produce an empty trail and therefore no markup.
 *
 * `items` adds the levels the route cannot describe on its own (test title,
 * doctor name) and is passed down from the page through Wrapper.
 *
 * The same schema is also written into the HTML source by the express server
 * (script.js), which is what crawlers and validators that do not run JS read.
 * That copy is dropped as soon as this component mounts: it describes the URL
 * the document was loaded with, so it would go stale on the first client-side
 * navigation, and keeping both would put two BreadcrumbList blocks on the page.
 */
function SchemaBreadcrumbs({ items = [] }) {
  const { pathname } = useLocation();
  const lang = Cookies.get('i18next') || 'en';

  useEffect(() => {
    document.getElementById('ecosense-breadcrumb')?.remove();
  }, []);

  const schema = getBreadcrumbSchema(getBreadcrumbTrail(pathname, lang, items));
  console.log(schema);
  if (!schema) return null;
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}

export default SchemaBreadcrumbs;
